import { render } from "./BuildingPassesOld.vue?vue&type=template&id=2f0feb1d"
import script from "./BuildingPassesOld.vue?vue&type=script&lang=js"
export * from "./BuildingPassesOld.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__